var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_vm._m(0),_c('div',[_vm._v(_vm._s(_vm.promiseError))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"myPaymentForm"}})])
}]

export { render, staticRenderFns }